import {connect} from "react-redux";
import ChangeAssignee from "./ChangeAssignee";
import {bindActionCreators} from "redux";
import { fetchAssignee, changeAssignee, assgineeAccount, fetchDealerListing, dealerManagerReassign } from "../../../../service/Assignment/action";
import { getCityByStateId, getFilter } from "../../../../service/Account/action";

const mapStateToProps = (state) => ({
    getAssignee:state.AssignmentReducer.getAssignee,
    ChangeAssigneeDetails:state.AssignmentReducer.ChangeAssignee,
    accountAssigneedetails:state.AssignmentReducer.accountAssigneedetails,
    accountFilterContent:state.Dropdown.accountFilterContent,
    geoCity:state.Dropdown.geoCity,
    getDealerListingForAssignee: state.AssignmentReducer.getDealerListingForAssignee,
    reassignDealerWithManager: state.AssignmentReducer.reassignDealerWithManager
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            fetchAssignee,
            changeAssignee,
            assgineeAccount,
            getFilter,
            getCityByStateId,
            fetchDealerListing, 
            dealerManagerReassign
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ChangeAssignee);
